/**
 *
 * @param origin
 */
export function getRacialTraitId(origin) {
    return origin.racialTraitId;
}
/**
 *
 * @param origin
 */
export function getAffectedRacialTraitId(origin) {
    return origin.affectedRacialTraitId;
}
/**
 *
 * @param origin
 */
export function getDefinitionKey(origin) {
    return origin.racialTraitDefinitionKey;
}
/**
 *
 * @param origin
 */
export function getAffectedRacialTraitDefinitionKey(origin) {
    return origin.affectedRacialTraitDefinitionKey;
}
/**
 *
 * @param origin
 */
export function getRacialTrait(origin) {
    return origin.racialTrait;
}
/**
 *
 * @param origin
 */
export function getAccessType(origin) {
    return origin.accessType;
}
